<template>
  <p class="inline">
    <component
      v-for="(orientation, index) in orientations"
      :key="index"
      :is="getElementType(orientation)"
      v-bind="getElementAttrs(orientation)"
    >{{ orientation.text }}</component>
  </p>
</template>

<script>
export default {
  name: "PrintAlertDynamicContent",

  props: {
    orientations: {
      type: Array,
      required: true
    }
  },

  methods: {
    getElementType(orientation) {
      if (orientation.tag) {
        return orientation.tag;
      }

      return orientation.href ? 'a' : 'span';
    },

    getElementAttrs(orientation) {
      if (orientation.href) {
        return {
          href: orientation.href,
          target: '_blank',
          rel: 'noopener noreferrer'
        }
      }
    }
  }
}
</script>
